
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"fill":"#fff","d":"M5.336 11.253a.999.999 0 101.328 1.494l4.5-4a.998.998 0 000-1.494l-4.5-4a.999.999 0 10-1.328 1.494L8.995 8l-3.66 3.253z"}})])
      }
    
      }
    